import type { Feature } from './types';

import { getEnvValue } from '../utils';

const title = 'MUD framework';

const config: Feature<{ isEnabled: true }> = (() => {
  if (getEnvValue('NEXT_PUBLIC_HAS_MUD_FRAMEWORK') === 'true') {
    return Object.freeze({
      title,
      isEnabled: true,
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
